import React from 'react';

const ComingSoon = ({ title, description }) => {
  return (
    <section className="ub-coming-soon">
      <div className="ub-coming-soon-content">
        <h1 className="ub-coming-soon-title">{title}</h1>
        <div className="ub-coming-soon-animation">
          <span className="ub-dot"></span>
          <span className="ub-dot"></span>
          <span className="ub-dot"></span>
        </div>
        <p className="ub-coming-soon-description">
          {description || 'We are working hard to bring you this feature. Stay tuned!'}
        </p>
      </div>
    </section>
  );
};

export default ComingSoon;
